<template>
  <div id="noon-report-body" class="h-full px-4">
    <div class="scroll-area overflow-y-hidden">
      <table>
        <tbody>
          <tr v-for="(item, index) in reports" :key="index">
            <th class="aisea-text-14-400-black">
              {{ item.item_name }}
            </th>
            <td class="aisea-text-14-400-gray" :class="{ alert: item.isAlert }">
              {{ getLabel(item.label) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("vesselNoonReportDetail");

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  components: {},
  computed: {
    ...mapState(["reportItems", "reportDetail"]),

    reports() {
      if (!this.reportItems.items) return [];

      return this.reportItems.items.map(item => {
        const report = this.reportDetail.find(val => {
          return item.id === val.item_id;
        });

        if (!report) {
          return {
            item_name: item.label,
            value: "",
            isAlert: false,
          };
        }

        const label = report.label ? report.label : "";
        const value = report.value ? report.value : "";
        const isAlert = report.is_alert ? report.is_alert : "";
        return {
          item_name: item.label,
          label: label,
          value: value,
          isAlert: isAlert,
        };
      });
    },
  },
  methods: {
    getLabel(label) {
      if (!label || label.length === 0) return "-";
      return label;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/vessel-noon-report.scss";

#noon-report-body {
  --vs-primary: 3, 155, 229;

  .scroll-area {
    overflow-y: auto;
    height: calc(100% - 108px);
  }

  .alert {
    color: $aisea-red;
    background-color: rgba($aisea-red, 0.1);
  }

  table {
    table-layout: fixed;
    border-spacing: 0;
    width: 100%;
  }

  th,
  td {
    padding: 5px 10px;
    word-break: break-all;
  }

  th {
    width: 200px;
    height: 50px;
  }

  td {
    height: 50px;
    border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
  }
}
@page {
  size: A4 portrait;
  margin: 0;
}

@media print {
  #noon-report-body {
    display: block;
    width: auto;
    height: auto;
    overflow: auto;

    table {
      border-spacing: 0;
    }

    th,
    td {
      height: 50px;
    }
  }
}
</style>
